import {useEffect} from "react";
import {Form, InputNumber} from "antd";
import initLabelStyles from "./SettingsFormHelper";
import ResultHeader from "../Table/ResultHeader";
import ResultRow from "../Table/ResultRow";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import ResultBody from "../Table/ResultBody";
import getSettingsItem from "./SettingsItem";
import ResultTable from "../Table/ResultTable";

export default function ({onValuesChange, values, defValues}) {

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Variable</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left'}}>User Preference</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left'}}>System Default</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Description</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        getSettingsItem({
                            value: values?.delta_ws_gt,
                            defaultValue: defValues?.delta_ws_gt,
                            onChange: (value) => {onValuesChange('delta_ws_gt', value)},
                            label: 'Max Surcharge',
                            description: 'T-SRC-001'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.delta_ws_lt,
                            defaultValue: defValues?.delta_ws_lt,
                            onChange: (value) => {onValuesChange('delta_ws_lt', value)},
                            label: 'Min Surcharge',
                            description: 'T-SRC-001'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.skew_angle,
                            defaultValue: defValues?.skew_angle,
                            onChange: (value) => {onValuesChange('skew_angle', value)},
                            label: 'Max Skew Angle',
                            description: 'T-SKW-001, T-SKW-002'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.max_ob_channel,
                            defaultValue: defValues?.max_ob_channel,
                            onChange: (value) => {onValuesChange('max_ob_channel', value)},
                            label: 'Max OB to Channel DS Length Ratio',
                            description: 'DSRL-002, DSRL-003'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.max_dsrl,
                            defaultValue: defValues?.max_dsrl,
                            onChange: (value) => {onValuesChange('max_dsrl', value)},
                            label: 'Max DSRL',
                            description: 'T-XS-01'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.head_loss,
                            defaultValue: defValues?.head_loss,
                            onChange: (value) => {onValuesChange('head_loss', value)},
                            label: 'Head Loss',
                            description: 'HL-01'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.velocity_head,
                            defaultValue: defValues?.velocity_head,
                            onChange: (value) => {onValuesChange('velocity_head', value)},
                            label: 'Velocity Head Change',
                            description: 'VH-01'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.conv_ratio,
                            defaultValue: defValues?.conv_ratio,
                            onChange: (value) => {onValuesChange('conv_ratio', value)},
                            label: 'Con Ratio Range',
                            description: 'CR-01'
                        })
                    }
                    {
                        getSettingsItem({
                            value: values?.transition_ratio_tol,
                            defaultValue: defValues?.transition_ratio_tol,
                            onChange: (value) => {onValuesChange('transition_ratio_tol', value)},
                            label: 'Transition Ratio Tol',
                            description: 'T-CES-01',
                            min: 0,
                            max: 1,
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}

const getRule = (message) => {
    return [{ required: true, message: message }]
}